module.exports = __webpack_public_path__ + "img/part4-dIcon10.991178cb.png";